module.exports = __webpack_public_path__ + "static/media/loading.643ae1e4.svg";